(function () {
  function initHowTo(root) {
    if (!root) return;

    var steps = Array.prototype.slice.call(
      root.querySelectorAll('[data-wondr-srz-howto-step]')
    );

    var images = Array.prototype.slice.call(
      root.querySelectorAll('[data-wondr-srz-howto-img]')
    );

    var stepLabel = root.querySelector('[data-wondr-srz-howto-step-label]');
    var stepTitle = root.querySelector('[data-wondr-srz-howto-step-title]');

    function activate(index) {
      var activeStepIndex = index + 1;

      steps.forEach(function (step, stepIndex) {
        step.classList.toggle('is-active', stepIndex === index);
      });

      images.forEach(function (img) {
        var imageStepIndex = parseInt(img.getAttribute('data-wondr-srz-howto-img-index'), 10);
        img.classList.toggle('is-active', imageStepIndex === activeStepIndex);
      });

      var active = steps[index];

      if (active && stepLabel) {
        stepLabel.textContent = 'Stap ' + activeStepIndex + ' van ' + steps.length;
      }

      if (active && stepTitle) {
        stepTitle.textContent = active.getAttribute('data-title') || '';
      }
    }

    steps.forEach(function (step, index) {
      if (step.dataset.wondrSrzHowtoBound === 'true') return;

      step.dataset.wondrSrzHowtoBound = 'true';

      step.addEventListener('click', function () {
        activate(index);
      });
    });

    var activeIndex = steps.findIndex(function (step) {
      return step.classList.contains('is-active');
    });

    activate(activeIndex > -1 ? activeIndex : 0);
  }

  function initAll(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-wondr-srz-howto]').forEach(function (section) {
      initHowTo(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();